import { render, staticRenderFns } from "./CatalogFolder.vue?vue&type=template&id=16929a55&"
import script from "./CatalogFolder.vue?vue&type=script&lang=js&"
export * from "./CatalogFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports